export function deepGet(obj: any, path: string) {
    const segments = [path]
    let i = 0;
    let val = obj;
    for (; i < segments.length; i++) {
      if (val === undefined) {
        return val;
      }
      val = val[segments[i]];
    }
    return val;
  }